export default __webpack_public_path__ + "static/media/form-mario.ac82ddf8.webp";